import React from "react";

export function Spinner({ className = "" }) {
  return (
    <div className={`inline-block h-5 w-5 animate-spin rounded-full border-2 border-brand border-t-transparent ${className}`} />
  );
}

export function SkeletonCard() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-3">
      <div className="skeleton h-28 w-full rounded-xl" />
      <div className="skeleton mt-3 h-3 w-3/4 rounded" />
      <div className="skeleton mt-2 h-3 w-1/2 rounded" />
      <div className="skeleton mt-3 h-8 w-full rounded-lg" />
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-16 text-center" data-testid="empty-state">
      {Icon && (
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-soft text-brand ring-8 ring-brand-soft/40">
          <Icon className="h-8 w-8" />
        </div>
      )}
      <h3 className="font-head text-lg font-bold text-slate-800">{title}</h3>
      {subtitle && <p className="mt-1.5 max-w-sm text-sm leading-relaxed text-slate-500">{subtitle}</p>}
      {action}
    </div>
  );
}
